<script setup>
import { getI18n } from '@/plugins/i18n'
import { DxPopup } from 'devextreme-vue/popup'
import { DxForm, DxItem } from 'devextreme-vue/form'
import { DxTextArea } from 'devextreme-vue/text-area'
import { DxTabPanel } from 'devextreme-vue/tab-panel'

import { useOrderStore } from '@/stores/order.store'
import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()
const orderStore = useOrderStore()

const props = defineProps({
  notificationId: {
    type: Number,
    default: null,
  },
})

const i18n = getI18n()

const emits = defineEmits(['cancel'])

const notificationDetails = (await webSiteStore.fetchNotificationDetailsByIdAsync(props.notificationId)).data
notificationDetails.transmission_order_status_value = orderStore.getLocalizedOrderStatuses().find(x => x.id === notificationDetails.transmission_status)?.name

const formItems = [
  {
    itemType: 'group',
    caption: i18n.t('common.mainInfo'),
    colCount: 3,
    items: [
      { dataField: 'transmission_order_number', label: { text: i18n.t('common.orderNumber')}, editorOptions: { readOnly: true }},
      { dataField: 'transmission_order_date', editorType: 'dxDateBox', label: { text: i18n.t('common.orderDate')}, editorOptions: { readOnly: true }},
      {
        dataField: 'transmission_order_status_value',
        label: { text: i18n.t('common.orderStatus')},
        editorOptions: { readOnly: true },

      },
      { dataField: 'message', label: { text: i18n.t('common.action')}, editorOptions: { readOnly: true }, colSpan: 3},
    ]
  }
]

const onHiding = () => { emits('cancel') }

</script>
<template>
  <dx-popup
    :visible="true"
    height="20rem"
    width="70rem"
    :resize-enabled="true"
    :hide-on-outside-click="true"
    :title="i18n.t('common.notification')"
    @hiding="onHiding"
  >
    <dx-tab-panel class="full-width full-height">
      <dx-item
        :title="$t('common.mainInfo')"
        template="main-info"
      />
      <template #main-info>
        <dx-form
          ref="form"
          class="q-mt-md"
          height="auto"
          :items="formItems"
          :form-data="notificationDetails"
        />
      </template>
      <dx-item
        :title="$t('common.rawMessage')"
        template="raw-info"
      />
      <template #raw-info>
        <dx-text-area
          class="q-mt-md raw-info"
          :value="JSON.stringify(notificationDetails.raw_message, null, 4)"
          height="100%"
          style="min-height: 20rem"
          :read-only="true"
        />
      </template>
    </dx-tab-panel>
  </dx-popup>
</template>
<style>
.raw-info .dx-texteditor-input {
  font-family: monospace !important;
}
</style>
